import React, { useRef } from 'react';
import styles from './SpecialCard.module.less';
import classNames from 'classnames';
import ztBlank from '../../static/zt_blank.png';
import dayjs from 'dayjs';

export default ({ specialInfo, handleClick, hasDelete, handleDelete }) => {
  const el = useRef(null);
  const handleNumber = (data = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+data)) {
      return data;
    }
    if (+data < 1000) {
      return data;
    }
    if (+data < 10000) {
      return `${(data / 1000).toFixed(1)}k`;
    }

    return `${(data / 10000).toFixed(1)}w`;
  };
  const handleMouseLeave = e => {
    if (e && e.currentTarget && e.currentTarget.className.indexOf(styles.image_mouse_out) < 0) {
      e.currentTarget.className = `${e.currentTarget.className} ${styles.image_mouse_out}`;

      const timer = setTimeout(() => {
        if (el.current && el.current.className.indexOf(styles.image_mouse_out) > -1) {
          el.current.className = classNames(styles.zt_card, styles.image_mouse_in);
        }
        clearTimeout(timer);
      }, 500);
    }
  };

  const handleZtCard = zt => () => {
    // eslint-disable-next-line no-unused-expressions
    handleClick && handleClick(zt);
  };

  const handleDeleteOper = par => e => {
    e.stopPropagation();
    e.preventDefault();
    // eslint-disable-next-line no-unused-expressions
    handleDelete && handleDelete(par);
  };

  const handleMouseOver = e => {
    if (e && e.currentTarget) {
      el.current = e.currentTarget;
    }
  };

  return (
    <div
      className={classNames(styles.zt_card, styles.image_mouse_in)}
      onMouseLeave={handleMouseLeave}
      onClick={handleZtCard(specialInfo)}
      key={`${specialInfo}_${specialInfo.ztId}`}
      onMouseOver={handleMouseOver}
    >
      <div className={styles.zt_card_img_box}>
        <img src={specialInfo.ztImg || ztBlank} alt="" className={styles.zt_card_img} />
      </div>
      {hasDelete && (
        <div className={styles.zt_card_delete} onClick={handleDeleteOper(specialInfo)}>
          <div alt="" className={styles.zt_card_delete_img}></div>
        </div>
      )}
      <div className={styles.zt_card_title}>{specialInfo.ztTitle}</div>
      <div className={styles.zt_card_info}>
        <div>{dayjs(specialInfo.pushTime).format('YYYY/MM/DD')}</div>
        <div></div>
        <div className={classNames(styles.zt_card_grid_icon)}>
          <div className={classNames(styles.zt_card_icon)}>
            <i className="iconfont icon-reads" />
            <span>{handleNumber(specialInfo.watchCount || 0)}</span>
          </div>
          <div className={classNames(styles.zt_card_icon)}>
            <i className="iconfont icon-zan" />
            <span>{handleNumber(specialInfo.zanCount || 0)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
